import {
  GET_PERMISSIONS,
  GET_PERMISSIONS_SUCCESS,
} from "../../actions/permission/types";
import {
  CREATE_ROLE,
  CREATE_ROLE_FAIL,
  CREATE_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  EDIT_ROLE,
  EDIT_ROLE_SUCCESS,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLE_DETAILS,
  GET_ROLE_DETAILS_SUCCESS,
} from "../../actions/role/types";

const initialState = {
  rolesLoading: false,
  roles: [],
  newRoleLoading: false,
  editRoleLoading:false,
  count: 0,
  roleDetails:{},
  roleDetailsLoading:false,
  deleteRoleLoading:false,

};

export const role = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_ROLE:
      return {
        ...state,
        newRoleLoading: true,
      };

    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        newRoleLoading: false,
      };
      case EDIT_ROLE:
        return {
          ...state,
          editRoleLoading: true,
        };
  
      case EDIT_ROLE_SUCCESS:
        return {
          ...state,
          editRoleLoading: false,
        };
      case DELETE_ROLE:
        return {
          ...state,
          deleteRoleLoading: true,
        };
  
      case DELETE_ROLE_SUCCESS:
        return {
          ...state,
          deleteRoleLoading: false,
        };
    case CREATE_ROLE_FAIL:
      return {
        ...state,
        newRoleLoading: false,
      };
    case GET_ROLES:
      return {
        ...state,
        rolesLoading: true,
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        rolesLoading: false,
        roles: payload.results,
        count: payload.count,
      };

      case GET_ROLE_DETAILS:
        return {
          ...state,
          roleDetailsLoading: true,
        };
      case GET_ROLE_DETAILS_SUCCESS:
        return {
          ...state,
          roleDetailsLoading: false,
          roleDetails: payload,
          
        };
  

    default: {
      return state;
    }
  }
};
